import React, {useContext} from "react";
import P from "../lib/P";
import {formatCurrency} from "../utils";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {useNavigation} from "@react-navigation/native";
import {StoreContext} from "./StoreContextProvider";
import BalanceIcon from "../assets/img/balance-icon.svg";
import {Image} from "react-native";
import GlassButton from "./GlassButton";

type Props = { opacity?: number };

const BalanceButton = ({opacity}: Props) => {
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const Context = useContext(StoreContext);
  const {balance, extendedUserData} = Context;
  const isFreePlay = extendedUserData.isNewPlayer || extendedUserData.freeShotNumber !== extendedUserData.freeShotCount;
  const isInsufficientFunds = !isFreePlay && balance / 100 < 3;

  return (
    <>
      <GlassButton disabled={opacity === 0} opacity={opacity}
                   borderColor={isInsufficientFunds ? 'rgba(255, 120, 120, 0.4)' : '#D0FFCC'}
                   overlayColor={isInsufficientFunds ? 'rgba(255, 60, 60, 0.25)' : 'rgba(45, 255, 26, 0.3)'}
                   onPress={() => navigation.navigate({name: 'account', params: {step: 1}})}>
        <>
          <Image source={BalanceIcon as any} style={{height: 28, width: 24}} resizeMode="contain"/>
          <P testID="wallet-balance" fontFamily="DavisSans-Medium" ml={8}>{balance ? formatCurrency(balance / 100) : '$0'}</P>
        </>
      </GlassButton>
    </>
  );
};

export default BalanceButton;
